export const AppManualUrl = "https://www.arielcorp.com/links/cKKY";
export const PackagerStandardsUrl = "https://www.arielcorp.com/links/cKvS";
export const SubmitFeedbackUrl = "https://www.arielcorp.com/links/cKKW";